import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-background">
      <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8 space-y-4">
        <div className="text-center text-sm text-muted-foreground">
          <p>
            &copy; {new Date().getFullYear()} {t('app.title')}. {t('footer.rights_reserved')}
          </p>
        </div>
        <div className="text-center text-xs text-muted-foreground">
          <p>
            {t('footer.order_consent.prefix')}{' '}
            <a href="/oferta" className="underline hover:text-foreground">
              {t('footer.order_consent.link')}
            </a>
            .
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
